var CONSTANT = function () {};

CONSTANT.ENV = "DEVELOPMENT";

CONSTANT.state = "active";

module.exports = CONSTANT;
